import { render, staticRenderFns } from "./RedactorContactCard.vue?vue&type=template&id=bb3d09fe&scoped=true&"
import script from "./RedactorContactCard.vue?vue&type=script&lang=js&"
export * from "./RedactorContactCard.vue?vue&type=script&lang=js&"
import style0 from "./RedactorContactCard.vue?vue&type=style&index=0&id=bb3d09fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d09fe",
  null
  
)

export default component.exports